import apiClient from './apiClient'

export interface RoleRef {
  role_id: number
  name: string
  description: string | null
}

export interface UserWithRoles {
  email: string
  roles: RoleRef[]
}

export const getRoles = async (): Promise<RoleRef[]> => {
  const response = await apiClient.get<RoleRef[]>('/admin/roles')
  return response.data
}

export const getUsers = async (): Promise<UserWithRoles[]> => {
  const response = await apiClient.get<UserWithRoles[]>('/admin/users')
  return response.data
}

export const assignRole = async (
  email: string,
  roleId: number
): Promise<void> => {
  await apiClient.post('/admin/roles/assign', { email, role_id: roleId })
}

export const removeRole = async (
  email: string,
  roleId: number
): Promise<void> => {
  await apiClient.post('/admin/roles/remove', { email, role_id: roleId })
}
